import Squircle from './Squircle';

export default Squircle;
